// src/components/custom-toast/CustomToast.js
import { Box, Typography } from '@mui/material';
import Iconify from './iconify';

export const CustomToast = ({ payload, t }) => (
    <Box
        sx={{
            maxWidth: '22rem',
            width: '100%',
            backgroundColor: '#fff',
            boxShadow: 'rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px',
            borderRadius: '0.5rem',
            pointerEvents: 'auto',
            display: 'flex',
            border: '1px solid',
            borderColor: 'rgba(0, 0, 0, 0.1)',
            animation: t.visible ? 'enter 0.2s ease-out' : 'leave 0.15s ease-in forwards',
            '@keyframes enter': {
                '0%': { transform: 'translateY(4px)', opacity: 0 },
                '100%': { transform: 'translateY(0)', opacity: 1 },
            },
            '@keyframes leave': {
                '0%': { transform: 'translateY(0)', opacity: 1 },
                '100%': { transform: 'translateY(4px)', opacity: 0 },
            },
        }}
    >
        <Box sx={{ flex: 1, width: 0, p: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Box sx={{ flexShrink: 0, pt: 0.5 }}>
                    <Iconify icon="iconoir:bell-notification-solid" width={30} height={30} sx={{ color: '#880152' }} />
                </Box>
                <Box sx={{ ml: 2, flex: 1 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.primary' }}>
                        {payload?.notification?.title}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 0.5, color: 'text.secondary' }}>
                        {payload?.notification?.body}
                    </Typography>
                </Box>
            </Box>
        </Box>
    </Box>
);
